import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '*',
    name: 'Home',
    // 路由懒加载：https://router.vuejs.org/zh/guide/advanced/lazy-loading.html
    // webpackPreload：https://www.jianshu.com/p/bbdcfeee7fbc
    component: () => import(/* webpackPreload: true */ '@/views/home'),
    meta: {
      title: '首页',
      showTab: true,
      keepAlive: true
    }
  },
  // 课程详情
  {
    path: '/index/courseDetail/:id',
    name: 'CourseDetail',
    component: () => import('@/views/home/detail/courseDetail'),
    meta: {
      title: '课程详情',
      keepAlive: false
    }
  },
  // 课程表
  {
    path: '/index/courseList',
    name: 'CourseList',
    component: () => import('@/views/home/modules/courseList'),
    meta: {
      title: '课程表',
      keepAlive: false
    }
  },

  // 课程详情
  {
    path: '/index/courseModelDetail/:id',
    name: 'courseModelDetail',
    component: () => import('@/views/home/detail/courseModelDetail'),
    meta: {
      title: '课程详情',
      keepAlive: false
    }
  },
  // 课堂点评列表
  {
    path: '/index/courseAppraise',
    name: 'CourseAppraise',
    component: () => import('@/views/home/modules/courseAppraise'),
    meta: {
      title: '课堂点评',
      keepAlive: false
    }
  },
  // 课堂点评详情
  {
    path: '/courseAppraise/detail/:id',
    name: 'ApprDetail',
    component: () => import('@/views/home/detail/apprDetail'),
    meta: {
      title: '点评详情',
      keepAlive: false
    }
  },
// 请假申请列表
  {
    path: '/index/leaveList',
    name: 'LeaveList',
    component: () => import('@/views/home/modules/leaveList'),
    meta: {
      title: '请假列表',
      keepAlive: false
    }
  },
  // 请假申请
  {
    path: '/LeaveList/leave',
    name: 'Leave',
    component: () => import('@/views/home/detail/leave'),
    meta: {
      title: '请假申请',
      keepAlive: false
    }
  },
  // 请假申请
  {
    path: '/LeaveList/leaveEdit/:id',
    name: 'Leave',
    component: () => import('@/views/home/detail/leaveEdit'),
    meta: {
      title: '请假申请',
      keepAlive: false
    }
  },
  // 课销列表
  {
    path: '/index/courseUsed',
    name: 'CourseUsed',
    component: () => import('@/views/home/modules/courseUsed'),
    meta: {
      title: '课销记录',
      keepAlive: false
    }
  },
  {
    path: '/courseUsed/detail/:id',
    name: 'CourseUsed',
    component: () => import('@/views/home/detail/courseUsedDetail'),
    meta: {
      title: '课销记录',
      keepAlive: false
    }
  },
  // 作业列表
  {
    path: '/index/workList/:tab',
    name: 'WorkList',
    component: () => import('@/views/home/modules/workList'),
    meta: {
      title: '作业列表',
      //keepAlive: true
    }
  },
  // 写作业
  {
    path: '/workList/detail/:id',
    name: 'WorkDetail',
    component: () => import('@/views/home/detail/workDetail'),
    meta: {
      title: '写作业',
      keepAlive: false
    }
  },
  // 约课
  {
    path: '/index/orderCourse',
    name: 'feedBackList',
    component: () => import('@/views/home/modules/orderCourse'),
    meta: {
      title: '学员约课',
      keepAlive: true
    }
  },
  // 约课1v1详情
  {
    path: '/index/orderCourseDetail',
    name: 'orderCourseDetail',
    component: () => import('@/views/home/modules/orderCourseDetail'),
    meta: {
      title: '约课详情',
    }
  },
  // 约课(班课)详情
  {
    path: '/index/orderClassCourseDetail',
    name: 'toOrderCourseDetail',
    component: () => import('@/views/home/modules/orderClassCourseDetail'),
    meta: {
      title: '约课详情',
    }
  },
  // 约课列表
  {
    path: '/index/orderCourseList',
    name: 'orderCourseList',
    component: () => import('@/views/home/modules/orderCourseList'),
    meta: {
      title: '约课列表',
    }
  },

  {
    path: '/orderCourse/detail/:id',
    name: 'orderCourseDetail',
    component: () => import('@/views/home/modules/orderCourseListDetail'),
    meta: {
      title: '课销记录',
      keepAlive: false
    }
  },
  // 校长信箱
  {
    path: '/index/feedBackList',
    name: 'feedBackList',
    component: () => import('@/views/home/modules/feedBackList'),
    meta: {
      title: '校长信箱',
    }
  },
  // 写信
  {
    path: '/feedBackList/feedback',
    name: 'newfeedback',
    component: () => import('@/views/home/detail/feedback'),
    meta: {
      title: '写信',
      keepAlive: false
    }
  },
  // 修改信件
  {
    path: '/feedBackList/feedbackEdit/:id',
    name: 'feedbackedit',
    component: () => import('@/views/home/detail/feedbackEdit'),
    meta: {
      title: '修改信件',
      keepAlive: false
    }
  },
  // 交易记录
  {
    path: '/user/balanceList',
    name: 'BalanceList',
    component: () => import('@/views/user/modules/balanceList'),
    meta: {
      title: '账户流水',
      //keepAlive: true
    }
  },
  // 积分记录记录
  {
    path: '/user/accumuList',
    name: 'accumuList',
    component: () => import('@/views/user/modules/accumuList'),
    meta: {
      title: '积分记录',
      //keepAlive: true
    }
  },
  // 交易记录详情
  {
    path: '/balance/detail',
    name: 'BalanceDetail',
    component: () => import('@/views/user/detail/balanceDetail'),
    meta: {
      title: '记录详情',
      //keepAlive: true
    }
  },
  // 我的
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user'),
    meta: {
      title: '我的',
      showTab: true
    }
  },
  // 报读课程
  {
    path: '/user/courseSubList',
    name: 'CourseSubList',
    component: () => import('@/views/user/modules/courseSubList'),
    meta: {
      title: '报读课程',
      keepAlive: false
    }
  },
  // 学员纪念册列表
  {
    path: '/user/studentYearBookList',
    name: 'StudentYearBookList',
    component: () => import('@/views/user/modules/studentYearBookList'),
    meta: {
      title: '学员纪念册',
      keepAlive: false
    }
  },
  // 学员纪念册详情
  {
    path: '/user/studentYearBookDetail/:id',
    name: 'StudentYearBookDetail',
    component: () => import('@/views/user/modules/studentYearBookDetail'),
    meta: {
      title: '纪念册详情',
      keepAlive: false
    }
  },
  {
    path: '/info',
    name: 'Info',
    component: () => import('@/views/info'),
    meta: {
      title: '消息',
      showTab: true
    }
  },
  // 消息详情
  {
    path: '/info/detail/:id',
    name: 'Detail',
    component: () => import('@/views/info/detail/infoDetail'),
    meta: {
      title: '消息详情',
      keepAlive: false
    }
  },

  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/user/error'),
    meta: {
      title: '错误信息',
      keepAlive: true
    }
  },


  {
    path: '/userform',
    name: 'userform',
    component: () => import('@/views/whitePage/userform'),
    meta: {
      title: '招生活动',
      keepAlive: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base:'/school/',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
